import { render, staticRenderFns } from "./SmsEmail.vue?vue&type=template&id=2dbfdfcb&scoped=true&"
import script from "./SmsEmail.vue?vue&type=script&lang=js&"
export * from "./SmsEmail.vue?vue&type=script&lang=js&"
import style0 from "./SmsEmail.vue?vue&type=style&index=0&id=2dbfdfcb&lang=scss&scoped=true&"
import style1 from "./SmsEmail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbfdfcb",
  null
  
)

export default component.exports